// Used in core.module.ts and login-routing.module.ts

// Angular
import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";

// Services/Types/Helpers
// RXJS/Store
import { PublicService } from "@carnegie-learning/data-access-angular-passport";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "app-background",
    templateUrl: "./background.component.html",
    styleUrls: ["./background.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BackgroundComponent implements OnInit, OnDestroy {
    logoImage = "assets/images/Full-Logo-Black-Blue.svg";//was cliFullLogoWhite.svg
    isDemo:boolean = false;

    public frontendBuildNumber: number;
    public apiBuildNumber: number;
    private ngUnsubscribe = new Subject();

    constructor(private publicService: PublicService) {}
    backgroundImageSource =
        " url('/assets/images/shapesBg.jpg') center center no-repeat fixed";
    modalOpen = true;

    ngOnInit() {
        this.frontendBuildNumber = (<any>window).buildNumber;
        this.isDemo = (<any>window).isDemo;

        this.publicService
            .getVersion()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((response) => {
                this.apiBuildNumber = response.version;
            });
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next(true);
        this.ngUnsubscribe.complete();
    }

    closeModal() {
        this.modalOpen = false;
    }
}
